import { Slider, SliderProps } from '@mui/material';

interface SliderFieldProps extends Omit<SliderProps, 'name' | 'onChange' | 'value'> {
	input: {
		value?: string | number;
		name?: string;
		onChange: (value: number | number[]) => void;
		[key: string]: any;
	};
	meta?: any;
}

const SliderField = ({input: {value, name, onChange, ...restInput}, meta, ...rest}: SliderFieldProps) => (
	<Slider
		{...rest}
		name={name}
		onChange={(e, v) => onChange(v as number | number[])}
		value={parseInt(value as string)}
	/>
);
export default SliderField;
